export const sortOnName = <T>(data: T): T =>
    // @ts-ignore
    data?.sort((a, b) => {
        if (!a || !b) return 0;

        const nameA = (typeof a === 'string' ? a : a.name).toUpperCase(); // ignore upper and lowercase
        const nameB = (typeof b === 'string' ? b : b.name).toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    });
